<template>
    <span>
        <textarea
            :autofocus="focus"
            :disabled="disabled"
            :id="id"
            :name="name"
            :value="textareaValue"
            autocapitalize="off"
            autocomplete="off"
            autocorrect="off"
            spellcheck="false"
        >
        </textarea>
        <assets-manager-modal
            v-if="!disabled && assetsManagerVisible"
            @change="onAssetSelection"
            :id="id"
            :name="name"
            :systemId="systemId"
            :systemName="systemName"
            :multiple="multiple"
            :refreshFields="refreshFields"
            :show="assetsManagerVisible"
            :registeredModuleName="registeredModuleName"
        >
        </assets-manager-modal>
    </span>
</template>

<script>
import Redactor from './Redactor.js';
export default Redactor;
</script>
